module.exports = __webpack_public_path__ + "static/backdrop-4a618d0070b74c1a5f82d7e583b7bed8.jpg";